import { render, staticRenderFns } from "./room-booking.vue?vue&type=template&id=07ad095e&"
import script from "./room-booking.vue?vue&type=script&lang=js&"
export * from "./room-booking.vue?vue&type=script&lang=js&"
import style0 from "./room-booking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports